import script from "./TemplatesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TemplatesPage.vue?vue&type=script&setup=true&lang=js"

export default script